import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { getFooterMenu } from '../utils/api'

export default function Footer(){
  const [menu, setMenu] = useState(null)

  useEffect(() => {
    getFooterMenu().then((res) => {
      setMenu(res) 
    })
  }, [])

  return (
    <footer>
      {
        menu && 
        menu.map((item) => (
          <NavLink key={item.ID} to={(item.url.replace(/^.*\/\/[^\/]+/, '') ) } className={`nav-link`}>
            {item.post_title}
          </NavLink>
        ))
      }
    </footer>
  )
}